import script from "./invoice-unselect-message.vue?vue&type=script&lang=ts&setup=true"
export * from "./invoice-unselect-message.vue?vue&type=script&lang=ts&setup=true"

import "./invoice-unselect-message.vue?vue&type=style&index=0&id=5c58694a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c58694a"]])

export default __exports__